import styled from "styled-components";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export default Body;
